<template>
    <heads>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing" />
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Edit Contact</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-4">
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Name'"/>
                            <breeze-input required v-model="form.name" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.name:''" />
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Mobile'"/>
                            <breeze-input required type="number" v-model="form.mobile" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.mobile:''" />
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Alternate Mobile'"/>
                            <breeze-input required type="number" v-model="form.alternate_mobile" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.alternate_mobile:''" />
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Email'"/>
                            <breeze-input type="email" required v-model="form.email" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.email:''" />
                        </div>
                        <div class="col-span-4 sm:col-span-4">
                            <breeze-label :required="true" :value="'Designation'"/>
                            <breeze-input required v-model="form.designation" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.designation:''" />
                        </div>
                        <div>
                            <breeze-label :value="'Status'"/>
                            <breeze-checkbox required v-model="form.status" :checked="form.status" />
                            <breeze-input-error :message="form.errors?form.errors.status:''" />
                        </div>

                    </div>
                    <button-link :href="route('heads.contact.list')" class="bg-red-500 mr-4 hover:bg-red-400">Cancel</button-link>
                    <breeze-button :disabled="form.processing">Save</breeze-button>
                    <exception />
                </form>
            </div>
        </div>
    </heads>
</template>

<script>
    import Heads from '@/Pages/Heads/Heads'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import BreezeButton from '@/Components/Button'
    import BreezeInputError from '@/Components/InputError'
    import ButtonLink from '@/Components/ButtonLink'
    import Exception from '@/Components/Exception'
    import { useForm } from '@inertiajs/inertia-vue3'
    import Loading from '@/Components/Loading'
    import BreezeCheckbox from '@/Components/Checkbox'

    export default {
        components: {
            Heads,
            ButtonLink,
            BreezeInput,
            BreezeLabel,
            BreezeInputError,
            BreezeButton,
            Exception,
            Loading,
            BreezeCheckbox
        },
        props:['contact'],
        data(){
            return{
                form: useForm({
                    '_method':'PUT',
                    name: this.contact.name,
                    mobile: this.contact.mobile,
                    alternate_mobile: this.contact.alternate_mobile,
                    designation: this.contact.designation,
                    email: this.contact.email,
                    status: this.contact.status,
                })
            }
        },
        methods: {
            submitForm() {
                this.form.post(route('heads.contact.update',this.contact.id),{
                    preserveScroll: true,
                    onSuccess: () => this.form.reset(),
                });
            },
        },
    }
</script>
